<template>
    <v-container>
        <v-layout>
            <v-row>
                <v-row style="margin-bottom:16px;">
                    <v-col md="12" lg="12" xl="12">
                        <v-card width="100%">
                            <v-card-text>
                                <v-row style="justify-content: flex-end;">
                                    <v-col>
                                        <v-menu
                                                v-model="vigenciainicio"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigenciainicio"
                                                    clearable
                                                    label="*Inicio"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigenciainicio= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigenciainicio"
                                                    @change="vigenciainicio = false"
                                                ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                    <v-col>
                                        <v-menu
                                                v-model="vigenciafin"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigenciafin"
                                                    clearable
                                                    label="*Inicio"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigenciafin= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigenciafin"
                                                    @change="vigenciafin = false"
                                                ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                    <v-col md="4">
                                        <v-select return-object item-text="text" item-value="value"  v-model="idusuario" dense outlined label="Usuarios" :items="ejecutivos" v-on:change="buscarejecutivo()"></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-text>                            
                        </v-card>
                    </v-col>
                    <v-col md="12" lg="12" xl="12">
                        <v-data-table
                            :headers="headers"
                            :items="CotizacionesDatos"        
                            :search="search"
                            class="elevation-3"
                            style="border-radius: 6px;"
                            id="TableBuy"
                            :loading="loadigtable"
                            loading-text="Loading... Please wait"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'skip_previous',
                                lastIcon: 'skip_next',
                                prevIcon: 'keyboard_arrow_left',
                                nextIcon: 'keyboard_arrow_right'
                            }"
                            >                     
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-toolbar-title>Reporte Ejecutivos</v-toolbar-title>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                                    <v-spacer></v-spacer>
                                    <!--<v-select dense outlined label="Actividad" v-model="idrechazocot" :items="RechazoCot"></v-select>-->
                                    <v-btn color="primary" @click="exportExcel">Descargar</v-btn>
                                </v-toolbar>
                            </template>
                        </v-data-table>    
                    </v-col>
                </v-row>                
            </v-row>
        </v-layout>
    </v-container>
</template>
<script>
    import axios from 'axios'
    import XLSX from 'xlsx'
    export default{
        data(){
            return{
                loadigtable:false,
                fechavigenciainicio:null,
                fechavigenciafin:null,
                vigenciafin:false,
                vigenciainicio:false,
                search:'',
                usuarios:[],
                idusuario:0,
                CotizacionesDatos:[],
                headers: [
                    {text:'Ncotizacion',sortable: false,value: 'ncotizacion',align:'center'},
                    {text:'Customer',sortable: false,value: 'Cliente',align:'center'},
                    {text:'Origen', value: 'Origen',align:'center' },
                    {text:'Destino', value: 'destino' ,align:'center'},
                    {text:'Modalidad', value: 'Destino' ,align:'center'},
                    {text:'Movimiento', value: 'Movimiento' ,align:'center'},
                    {text:'Fecha envio', value: 'Fechsend' ,align:'center'},
                    {text:'Motivo', value: 'RechazoCot' ,align:'center'},
                    {text:'Reporte', value: 'ReporteActividad' ,align:'center'},
                ],
                ejecutivos:[],
                RechazoCot:[],
            }
        },
        computed: {
            computedDateFormattvigenciafin () {
                return this.formatDate(this.fechavigenciafin)
            },
            computedDateFormattvigenciainicio () {
                return this.formatDate(this.fechavigenciainicio)
            },
        },
        created () {
            
            this.select();
        },
        methods:{
            /******************************CONSULTAS***************************** */
            buscarejecutivo(){
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                me.loadigtable = true;
                var repcot = [];
                me.CotizacionesDatos = [];
                if(me.fechavigenciainicio != null && me.fechavigenciafin!= null){
                    
                    console.log('entra fecha')
                    axios.get('api/Cotizaciones/ListarcotizacionreporteFecha/'+ me.idusuario.value + '/' + me.fechavigenciainicio + '/' + me.fechavigenciafin,configuracion).then(function(response){                
                        repcot = response.data;
                        repcot.map(function(x){

                            var RechazoCot = "";

                            if(x.idreport_cot != 0 ){
                                var indexpol = me.RechazoCot.findIndex(y => y.value == x.idreport_cot);
                                    RechazoCot = me.RechazoCot[indexpol].text;
                            }

                            me.CotizacionesDatos.push({
                                ncotizacion:x.ncotizacion,
                                Cliente:x.ncustumer,
                                Origen:x.origen,
                                Destino:x.destino,
                                Modalidad:x.modalidad,
                                Movimiento:x.movimiento,
                                Fechsend:x.fechsend,
                                RechazoCot:RechazoCot,
                                ReporteActividad:x.reporteActividad ,
                            });
                        })
                        me.loadigtable = false;
                    }).catch(function(error){
                        me.loadigtable = false;
                        console.log(error);
                    });
                }
                axios.get('api/Cotizaciones/Listarcotizacionreporte/'+ me.idusuario.value,configuracion).then(function(response){                
                    repcot = response.data;
                    repcot.map(function(x){

                        var RechazoCot = "";

                        if(x.idreport_cot != 0 ){
                            var indexpol = me.RechazoCot.findIndex(y => y.value == x.idreport_cot);
                                RechazoCot = me.RechazoCot[indexpol].text;
                        }

                        me.CotizacionesDatos.push({
                            ncotizacion:x.ncotizacion,
                            Cliente:x.ncustumer,
                            Origen:x.origen,
                            Destino:x.destino,
                            Modalidad:x.modalidad,
                            Movimiento:x.movimiento,
                            Fechsend:x.fechsend,
                            RechazoCot:RechazoCot,
                            ReporteActividad:x.reporteActividad ,
                        });
                    })
                    me.loadigtable = false;
                }).catch(function(error){
                    me.loadigtable = false;
                    console.log(error);
                });
            },
            /***************exportar a excel******************* */
            exportExcel: function (n) {
                
                var NombreArchivo = 'Reporte Cotizaciones';


                let data = XLSX.utils.json_to_sheet(this.CotizacionesDatos)
                const workbook = XLSX.utils.book_new()
                const filename = NombreArchivo;
                XLSX.utils.book_append_sheet(workbook, data, filename)
                XLSX.writeFile(workbook, `${filename}.xlsx`)
                },
            /**************************************** */
            formatDate(date){
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            /**********************CATALOGOS********************* */
            select(){
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                var usuariosarray = [];
                var RechazoCot = [];
                axios.get('api/CatCotizaciones/Select',configuracion).then(function(response){                
                  RechazoCot=response.data;
                  RechazoCot.map(function(x){
                      me.RechazoCot.push({text:x.nombre,value:x.idcatcot});
                  });
                }).catch(function(error){
                    console.log(error);
                });
                axios.get('api/Usuarios/SelectReportSC',configuracion).then(function(response){
                    usuariosarray=response.data;
                    usuariosarray.map(function(x){
                        me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                    });            
                }).catch(function(error){
                    console.log(error);
                });
            },
        }        
    }
    
</script>